import { useState, useCallback } from 'react';

import { validateAttendees as validateAttendeesHelper, buildAttendeeSplitActions as buildAttendeeSplitActionsHelper } from './checkoutAttendeeHelpers';

/**
 * Production-grade hook to manage attendee state and validation during checkout.
 * Encapsulates attendee data, validation errors, and cart split logic.
 */
export function useCheckoutAttendees() {
  // Map of lineItemId -> array of attendee objects { guestName, guestEmail }
  const [attendeesData, setAttendeesData] = useState({});
  const [attendeeFormErrors, setAttendeeFormErrors] = useState({});

  const validateAttendees = useCallback((cart) => {
    const { hasErrors, errors } = validateAttendeesHelper(cart, attendeesData);
    setAttendeeFormErrors(errors);
    return { hasErrors, errors };
  }, [attendeesData]);

  const buildAttendeeSplitActions = useCallback((cart) => {
    return buildAttendeeSplitActionsHelper(cart, attendeesData);
  }, [attendeesData]);

  // Prefix setter with _ to indicate it's not currently bound to an input in the main component
  const _setAttendeesData = setAttendeesData;

  return {
    attendeesData,
    attendeeFormErrors,
    setAttendeesData: _setAttendeesData,
    setAttendeeFormErrors,
    validateAttendees,
    buildAttendeeSplitActions,
  };
}
